<template>
  <div
    class="w-full"
    data-cy="tickets-summary"
  >
    <div class="flex items-center justify-between gap-2">
      <div class="font-medium text-gray-700">
        {{ props.section.$t('poly.tickets') }}
      </div>
      <button
        type="button"
        class="text-sm text-primary-500 hover:underline"
        @click="emit('edit', props.ticketTypes)"
      >
        {{ props.section.$t('poly.tickets.edit') }}
      </button>
    </div>

    <div
      v-for="ticketType in props.ticketTypes"
      :key="ticketType.id"
      class="flex items-start justify-between text-gray-500 gap-2 leading-relaxed"
    >
      <div class="flex-1 flex items-start gap-1">
        <div>
          {{ ticketType.quantity }}x
        </div>
        <div>
          {{ ticketType[props.lang]?.name }}
        </div>
      </div>
      <div>
        {{ useFormatPrice(ticketType.price * ticketType.quantity, props.event?.general?.ticketing?.currency) }}
      </div>
    </div>

    <slot />

    <div
      class="flex items-center justify-between gap-2 border-b border-gray-200 mt-2 pb-2 text-gray-700 font-medium"
    >
      <div>
        {{ props.section.$t('poly.tickets.total') }}
      </div>
      <div data-cy="tickets-summary-total-price">
        {{ useFormatPrice(props.totalPrice, props.event?.general?.ticketing?.currency) }}
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  ticketTypes: {
    type: Array,
    required: true,
  },
  event: {
    type: Object,
    required: true,
  },
  section: {
    type: Object,
    required: true,
  },
  lang: {
    type: String,
    required: true,
  },
  totalPrice: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['edit']);
</script>
